export default "__VITE_ASSET__BUqjj9ns__"